import { oz } from '@weft/utils';

export const FIXED_PRODUCT_TYPES = Object.freeze({
  Service: 'Service',
  CommercialTerms: 'CommercialTerms',
  Credit: 'Credit',
});

export const FixedProductTypeSchema = oz.nativeEnum(FIXED_PRODUCT_TYPES).openapi('FixedProductType');

export type FixedProductType = oz.infer<typeof FixedProductTypeSchema>;